import { graphql } from '@gql';

export const GET_PROJECTS_PAGED = graphql(`
    query GetProjectsPaged(
        $first: Int
        $last: Int
        $after: Cursor
        $before: Cursor
        $where: ProjectWhereInput
        $orderBy: ProjectOrder
        $showTags: Boolean! = true
        $showCountries: Boolean! = true
        $showCreator: Boolean! = true
        $showSecurityResponsible: Boolean! = true
        $showOrganization: Boolean! = true
        $showDescription: Boolean! = true
    ) {
        projects(
            first: $first
            last: $last
            after: $after
            before: $before
            where: $where
            orderBy: $orderBy
        ) {
            totalCount
            pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
            }
            edges {
                cursor
                node {
                    id
                    name
                    description @include(if: $showDescription)
                    assetsUpdateTime
                    creator @include(if: $showCreator) {
                        id
                        gid
                        firstName
                        lastName
                        email
                    }
                    securityResponsible @include(if: $showSecurityResponsible) {
                        id
                        firstName
                        lastName
                        email
                    }
                    organization @include(if: $showOrganization) {
                        id
                        name
                    }
                    milestone {
                        id
                        name
                        projectPhase {
                            id
                            name
                        }
                    }
                    status {
                        id
                        name
                    }
                    type {
                        id
                        name
                    }
                    ...ProjectCustomerPartial
                    ...ProjectLocationPartial
                    ...ProjectPlantPartial
                    ...ProjectProfilePartial
                    projectCountries @include(if: $showCountries) {
                        country {
                            id
                            name
                        }
                    }
                    tags @include(if: $showTags) {
                        id
                        name
                    }
                    updateTime
                    createTime
                }
            }
        }
    }
`);

export const GET_PROJECT = graphql(`
    query GetProject($id: ID!) {
        projects(where: { id: $id }) {
            edges {
                node {
                    id
                    name
                    description
                    assetsUpdateTime
                    creator {
                        id
                        gid
                        firstName
                        lastName
                        email
                    }
                    securityResponsible {
                        id
                        firstName
                        lastName
                        email
                    }
                    organization {
                        id
                        name
                    }
                    milestone {
                        id
                        name
                        projectPhase {
                            id
                            name
                        }
                    }
                    status {
                        id
                        name
                    }
                    type {
                        id
                        name
                    }
                    ...ProjectCustomerPartial
                    ...ProjectLocationPartial
                    ...ProjectPlantPartial
                    ...ProjectProfilePartial
                    participants {
                        ... on ProjectUser {
                            id
                            user {
                                id
                                gid
                                firstName
                                lastName
                                email
                            }
                        }
                        ... on OrganizationUser {
                            id
                            user {
                                id
                                gid
                                firstName
                                lastName
                                email
                            }
                        }
                    }
                    projectAttributes {
                        id
                        label
                        sequence
                        type
                        value
                    }
                    projectCountries {
                        country {
                            id
                            name
                        }
                    }
                    tags {
                        id
                        name
                    }
                    updateTime
                    createTime
                }
            }
        }
    }
`);
